// TODO: DEPRECATED

function setGlobals({ uiBlock, events, router }) {
    window.getUi = () => uiBlock;
    window.events = events;
    app.router = router;
}

export default setGlobals;
